import { useState } from "react";
import { useTranslation } from "react-i18next";
import { tabList } from "./sisense.constants";
import {
  ContentWrapper,
  PageTitle,
  CheckingAccessMessage,
} from "../../../styled-components/shared";
import { Tab, Tabs } from "@material-ui/core";
import { SisenseDashboard } from "./sisenseDashboard";
import { useDGAMLicenseCheck } from "../../../authentication/licensing";
import NoAccessMessage from "../../../components/common/NoAccessMessage";

export const SisenseDashboardContainer = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const { isDGAMLicensed, loadingLicense } = useDGAMLicenseCheck();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <>
      <ContentWrapper
        style={{
          cursor: loadingLicense ? "wait" : "default",
          opacity: loadingLicense ? "0.4" : "1",
        }}
      >
        <PageTitle>{t("report.historicalReports")}</PageTitle>

        {!isDGAMLicensed && !loadingLicense && (
          <NoAccessMessage>{t("licenseUpgradeText")}</NoAccessMessage>
        )}

        {isDGAMLicensed && !loadingLicense && (
          <>
            <Tabs
              value={activeTab || 0}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              aria-label="full width tabs example"
              fullWidth
            >
              {tabList.map((tList, index) => (
                <Tab key={index} label={tList.label} />
              ))}
            </Tabs>
            {activeTab === 0 && <SisenseDashboard tab={0} />}
            {activeTab === 1 && <SisenseDashboard tab={1} />}
            {activeTab === 2 && <SisenseDashboard tab={2} />}
            {activeTab === 3 && <SisenseDashboard tab={3} />}
          </>
        )}
      </ContentWrapper>
    </>
  );
};
